module.exports = __webpack_public_path__ + "img/links.0c2bf1c0.svg";